import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';

const MainContainer = styled.div`
    width: 300px;
    max-width: 100%;

 @media (min-width: 768px) {
     width: 600px;
  }
  
  @media(min-width: 992px) {
    width: 900px;  
  }

`;

const VideoContainer = styled.div`
  margin: auto;
  width: 100%;
  position: relative;
	padding-bottom: 56.25%; /* 16:9 */
	padding-top: 25px;
	height: 0;
  
  iframe {
    position: absolute;
  	top: 0;
	  left: 0;
  	width: 100%;
	  height: 100%;
  }
`;

class VideoModal extends React.Component {
    render() {
        const {isOpen, close, video} = this.props;
        return (
          <Modal
            isOpen={isOpen}
            onRequestClose={() => close()}
            style={{
                overlay: {
                    position: `fixed`,
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: `rgba(0, 0, 0, 0.75)`,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                },
                content: {
                    position: `relative`,
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    border: `none`,
                    background: `none`,
                    padding: 0,
                    overflow: `auto`,
                    WebkitOverflowScrolling: `touch`,
                },
            }}
            contentLabel="Modal"
          >
              <MainContainer>
                  <VideoContainer>
                      <iframe width="560" height="349" src={video} frameBorder="0"
                              allowFullScreen/>
                  </VideoContainer>
              </MainContainer>
          </Modal>
        );
    }
}

export default VideoModal;



// WEBPACK FOOTER //
// ./src/components/Modals/VideoModal.js